import { useEffect, useState } from "react";

import { makeRequest } from "../utils/request";

export type SupportedModelsMap = Record<string, Record<string, string[]>>;

type SupportedModelsResponse = SupportedModelsMap | { data: SupportedModelsMap };

const normalizeSupportedModels = (response: SupportedModelsResponse): SupportedModelsMap => {
  if ("data" in response) {
    return response.data as SupportedModelsMap;
  }

  return response as SupportedModelsMap;
};

export const useEvaluatorSupportedModels = () => {
  const [supportedModels, setSupportedModels] = useState<SupportedModelsMap>({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchSupportedModels = async () => {
      try {
        const response = await makeRequest<SupportedModelsResponse>("/v1/evaluators/supported-models");
        setSupportedModels(normalizeSupportedModels(response));
      } catch (err) {
        setError(err instanceof Error ? err.message : "Failed to fetch evaluator models");
      } finally {
        setLoading(false);
      }
    };

    fetchSupportedModels();
  }, []);

  const getApiProviders = (modality = "text") => {
    return Object.keys(supportedModels[modality] || {});
  };

  const getModelsForProvider = (modality = "text", apiProvider?: string) => {
    if (!apiProvider) {
      return [];
    }

    return supportedModels[modality]?.[apiProvider] || [];
  };

  return {
    supportedModels,
    loading,
    error,
    getApiProviders,
    getModelsForProvider,
  };
};
